import { render, staticRenderFns } from "./action-modal.vue?vue&type=template&id=37610948&scoped=true&"
import script from "./action-modal.vue?vue&type=script&lang=ts&"
export * from "./action-modal.vue?vue&type=script&lang=ts&"
import style0 from "./action-modal.vue?vue&type=style&index=0&id=37610948&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37610948",
  null
  
)

export default component.exports